$(document).ready(function () {

$('.scrol_contnet').removeClass('hidden');

// marquee
 $('.str3-2').liMarquee({
   circular:true,
   startShow:true,
   scrollDelay: 0,
   direction: 'left'
   });

  // if (screen.width > 990) {
  //   $(document).scroll(function() {
  //     if ( $(document).scrollTop() >= 50 ) {
  //         $('header.header').css('position','unset');
  //         $('.header__heading-logo-wrapper img').css('filter','invert(1)');
  //         $('.header__menu-item').css('color',"#000");
  //     } else {
  //         $('header.header').css('position','absolute');
  //         $('.header__heading-logo-wrapper img').css('filter','invert(0)');
  //         $('.header__menu-item').css('color',"#fff");
  //     }
  //   });
  
    // if ( $(document).scrollTop() >= 50 ) {
    //     $('header.header').css('position','unset');
    //     $('.header__heading-logo-wrapper img').css('filter','invert(1)');
    //     $('.header__menu-item').css('color',"#000");
    // } else {
    //     $('header.header').css('position','absolute');
    //     $('.header__heading-logo-wrapper img').css('filter','invert(0)');
    //     $('.header__menu-item').css('color',"#fff");
    // }
  // }

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  $('svg.icon.icon-caret.qty-plus').click(function(){
    $('.price-per-item__container quantity-input [name="plus"]').trigger('click');
  })

  $('svg.icon.icon-caret.qty-minus').click(function(){
    $('.price-per-item__container quantity-input [name="minus"]').trigger('click');
  })

  $(document).on('click','.coll-grod-color-swatches label',function(){
    $('.coll-grod-color-swatches label').removeClass('activated');
    $(this).addClass('activated');
    var clk = $(this).attr('data-val');
    $(this).parents('.card__information').find('.product-variantsss .product-variantsss-values').each(function(){
        var lbl = $(this).attr('var-lbl').toLowerCase();
        if(lbl.indexOf(clk) > -1){
        var slctedimg = $(this).attr('varinat-img');
         if(slctedimg.indexOf('.gif') > -1){
         }else{
        $(this).parents('.card-wrapper.product-card-wrapper').find('.card__media .media img').attr('src',slctedimg);
            $(this).parents('.card-wrapper.product-card-wrapper').find('.card__media .media img').attr('srcset',slctedimg);
         }
         return false;
        }
    })
  })
  
});